import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { OrgSelect } from "@/components/common/OrgSelect";
import { ModuleManager } from "@/components/common/ModuleManager";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function PlatformModules() {
  const [orgId, setOrgId] = useState(null);
  const [facilities, setFacilities] = useState([]);
  const [scope, setScope] = useState("org"); // "org" or a facility id

  useEffect(() => {
    if (!orgId) return;
    setScope("org");
    api.get(`/facilities?organisation_id=${orgId}`).then((r) => setFacilities(r.data)).catch(() => setFacilities([]));
  }, [orgId]);

  return (
    <div data-testid="platform-modules-page">
      <PageHeader title="Module Management" subtitle="Activate or deactivate modules per organisation, then override at facility level. Navigation adapts automatically."
        actions={<div className="flex items-center gap-2">
          <OrgSelect value={orgId} onChange={setOrgId} />
          <Select value={scope} onValueChange={setScope}>
            <SelectTrigger className="w-[240px] bg-white" data-testid="module-scope-select"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="org">Organisation defaults</SelectItem>
              {facilities.map((f) => <SelectItem key={f.id} value={f.id} data-testid={`module-fac-${f.id}`}>{f.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>} />

      <div className="bg-white/50 border border-slate-200 rounded-md p-5">
        {orgId && <ModuleManager orgId={orgId} facilityId={scope === "org" ? null : scope} canEdit />}
      </div>
    </div>
  );
}
